import React from "react";
import { useHistory } from "react-router-dom";
import TableChartIcon from "@mui/icons-material/TableChart";

export const Container_List = ({ titulo, cards }) => {
  const history = useHistory();
  const onPush = (ruta) => {
    // console.log(ruta)
    if (ruta === "/Credito/CarteraClientes") {
      history.push(ruta, {
        permisos: [
          { idsucursal: 1 },
          { idsucursal: 2 },
          { idsucursal: 11 },
          { idsucursal: 12 },
          { idsucursal: 21 },
          { idsucursal: 22 },
          { idsucursal: 31 },
          { idsucursal: 32 },
          { idsucursal: 41 },
          { idsucursal: 42 },
          { idsucursal: 51 },
          { idsucursal: 52 },
          { idsucursal: 61 },
        ],
        filtro: "C",
        ruta: 'C'
      });
      return;
    }
    if (ruta === "/Postventa/Dashboard") {
      history.push(ruta, {
        sucursales: "",
        adr: "",
        ejercicio: new Date().getFullYear(),
        periodo_inicio: new Date().getMonth() + 1,
        periodo_fin: new Date().getMonth() + 1,
        regresar: false
      });
      return;
    }
    if (ruta === "/Ventas/Cotizaciones") {
      localStorage.removeItem("filtrosCotizaciones");
      // return;
    }
    history.push(ruta);
  };
  return (
    <div className="container-boxes-list">
      <div className="container-boxes-list-titulo">
        <div className="container-boxes-list-titulo-text">{titulo}</div>
        <div className="container-boxes-list-titulo-efecto">
          <div className="container-boxes-list-titulo-efecto-bl"></div>
          <div className="container-boxes-list-titulo-efecto-circle"></div>
          <div className="container-boxes-list-titulo-efecto-br"></div>
        </div>
      </div>
      <div className="container-boxes-list-container">
        {cards === undefined || cards === null || cards.lenght === 0 ? (
          <div></div>
        ) : (
          cards.map((card) => (
            <div
              className="container-boxes-list-container-card"
              onClick={() => onPush(card.ruta)}
            >
              <TableChartIcon /> {card.titulo}
            </div>
          ))
        )}
      </div>
    </div>
  );
};
